import { render } from "./ResourceList.vue?vue&type=template&id=432ee4e3&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"

import "./ResourceList.vue?vue&type=style&index=0&id=432ee4e3&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1097443038/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432ee4e3"]])

export default __exports__